import React, { Component } from "react";
import Head from "next/head";
import getConfig from "next/config";
import { connect } from "react-redux";

import withRouterPageLayout from "@components/withRouterPageLayout";
import ErrorPage from "@containers/ErrorPage";
import { getPage } from "@store/pages/actions";
import Breadcrumbs from "@components/Breadcrumbs";
import ContentEditorView from "@components/ContentEditorView/index";

const {
  publicRuntimeConfig: {
    content: { websiteTitle },
    settings: { websiteName },
  },
} = getConfig();

class Page extends Component {
  static async getInitialProps(ctx) {
    const { reduxStore, query, res, asPath: urlAsPath } = ctx;

    const pageRes = await reduxStore.dispatch(getPage(query.urlKey));

    if (!pageRes) {
      if (res) {
        res.statusCode = 404;
      }
    }

    return {
      urlAsPath,
      pageRes,
      query,
    };
  }

  render() {
    const { pageRes } = this.props;

    if (!pageRes) {
      return <ErrorPage layout="404" />;
    }

    let parsedEditorContent;

    if (pageRes.content_object && pageRes.content_object.length > 10) {
      try {
        parsedEditorContent = JSON.parse(pageRes.content_object);
      } catch (error) {
        parsedEditorContent = false;
      }
    }

    const fullWidthContainer = {
      left: "50%",
      right: "50%",
      marginLeft: "-50vw",
      marginRight: "-50vw",
      width: "100vw",
      position: "relative",
    };

    return (
      <>
        <Head>
          <title>{(pageRes && pageRes.title) || websiteTitle}</title>
          {!!pageRes.description && (
            <meta name="description" content={pageRes.description} />
          )}
          {!!pageRes.keywords && (
            <meta name="keywords" content={pageRes.keywords} />
          )}
        </Head>

        <Breadcrumbs
          breadcrumbs={[
            {
              id: 1,
              level: 99,
              name: pageRes.title,
            },
          ]}
        />

        {pageRes.content_heading && (
          <h1 className={websiteName === "bricostore" ? "bd-display2" : ""}>
            {pageRes.content_heading}
          </h1>
        )}

        <div style={pageRes.template === "empty" ? fullWidthContainer : null}>
          {parsedEditorContent ? (
            <ContentEditorView content={parsedEditorContent} />
          ) : (
            <>
              {pageRes.content && (
                <div
                  className="Cms"
                  dangerouslySetInnerHTML={{ __html: pageRes.content }}
                />
              )}
            </>
          )}
        </div>
      </>
    );
  }
}

Page.pageLayout = "default";

export default withRouterPageLayout(
  connect(null, {
    getPage,
  })(Page)
);
